import { render } from "./MessageBox.vue?vue&type=template&id=2e248dfd"
import script from "./MessageBox.vue?vue&type=script&lang=ts"
export * from "./MessageBox.vue?vue&type=script&lang=ts"
script.render = render

export default script